import(/* webpackMode: "eager" */ "/opt/buildhome/repo/node_modules/next/dist/client/app-dir/link.js");
;
import(/* webpackMode: "eager" */ "/opt/buildhome/repo/node_modules/next/dist/client/image-component.js");
;
import(/* webpackMode: "eager", webpackExports: ["UpcomingEvents"] */ "/opt/buildhome/repo/src/components/events/upcoming-events.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["NewsletterSignup"] */ "/opt/buildhome/repo/src/components/newsletter-signup.tsx");
